import { Api } from '../../axios-config/AxiosConfig';
import { ApiException } from '../ApiException';
import { Environment } from '../../../environment';

export interface C4Usuarios {
  id?: string | number;
  nome: string;
  descricao: string;
}

const createUsuario = async (
  dados: C4Usuarios
): Promise<string | number > => {
  try {
    const { data } = await Api.post(
      `${Environment.API_GATEWAY}/arquiteturac4model/api/v1/Usuarios`,
      dados,
      {
        headers: {
          idTenant: 'gvdasa-cloud',
        },
      }
    );
    return data as string | number;

  } catch (error: any) {
    throw new ApiException(error.data.data.errors.erro || 'Erro ao salvar o usuário');
  }
};

const getAllUsuarios = async (
  page: string,
  limite = 25,
  offset = 0,
  NomeParte?: string,
  order?: string,
  sortBy?: string
): Promise<{ data: C4Usuarios[]; totalCount: number } | ApiException> => {
  try {
    // Construindo a query string com os parâmetros
    let queryParams = `?page=${page}&limite=${limite}&offset=${offset}`;

    // Adiciona filtro se existir
    if (NomeParte && NomeParte.trim()) {
      queryParams += `&NomeParte=${encodeURIComponent(NomeParte)}`;
    }

    // Adiciona ordenação se existir
    if (sortBy && order) {
      queryParams += `&sortBy=${sortBy}&order=${order}`;
    }

    const { data, headers } = await Api.get(
      `${Environment.API_GATEWAY}/arquiteturac4model/api/v1/Usuarios${queryParams}`,
      {
        headers: {
          idTenant: 'gvdasa-cloud',
        },
      }
    );

    if (data) {
      return {
        data: data as C4Usuarios[],
        totalCount: Number(headers['x-total-count']),
      };
    }

    throw new ApiException('Não foi possível consultar as usuários.');
  } catch (error: any) {
    console.error('Erro ao consultar usuários:', error);
    return new ApiException(
      error.data.data.erro || 'Erro ao consultar usuários.'
    );
  }
};

const getUsuariosById = async (
  id: string | number
): Promise<C4Usuarios | ApiException> => {
  try {
    const { data } = await Api.get(
      `${Environment.API_GATEWAY}/arquiteturac4model/api/v1/Usuarios/${id}`,
      {
        headers: {
          idTenant: 'gvdasa-cloud',
        },
      }
    );
    if (data) {
      return data as C4Usuarios;
    } else {
      return new ApiException('Não foi possível exibir os dados do usuário');
    }
  } catch (error: any) {
    console.error(error);
    return new ApiException(error.data.data.erro || 'Erro ao buscar os dados do usuário');
  }
};

const deleteUsuarioById = async (
  id: string | number
): Promise<void | ApiException> => {
  try {
    await Api.delete(
      `${Environment.API_GATEWAY}/arquiteturac4model/api/v1/Usuarios/${id}`,
      {
        headers: {
          idTenant: 'gvdasa-cloud',
        },
      }
    );
    return;
  } catch (error: any) {
    console.error(error);
    return new ApiException(error.data.data.erro || 'Erro ao excluir o usuário');
  }
};

const updateUsuarioById = async (
  id: string | number,
  dados: C4Usuarios
): Promise<void> => {
  try {
    await Api.put(
      `${Environment.API_GATEWAY}/arquiteturac4model/api/v1/Usuarios/${id}`,
      dados,
      {
        headers: {
          idTenant: 'gvdasa-cloud',
        },
      }
    );
    return;
  } catch (error: any) {
    throw new ApiException(error.data.data.erro || 'Erro ao salvar o usuário');
  }
};

export const C4ModelUsuariosService = {
  create: createUsuario,
  getAll: getAllUsuarios,
  getById: getUsuariosById,
  updateById: updateUsuarioById,
  deleteById: deleteUsuarioById,
};